import React from 'react';
import { Container, Row, Col, Card } from 'reactstrap'
import Header from '../../Componentes/header'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Nav from './Componentes/aspiranteNav'

export default class AspiranteInicio extends React.Component {
    formatoPago = (pago) =>{
        switch(pago){
            case 'PENDIENTE':
            return <div className="inline-block text-warning">PENDIENTE</div>
            
            case 'RECHAZADO':
            return <div className="inline-block text-danger">RECHAZADO</div>
            
            case 'APROBADO':
            return <div className="inline-block text-success">APROBADO</div>

            default:
            break;
        }
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                <Col className="bg-light" lg="3">
                        <Nav nombre_completo={sessionStorage.getItem('nombre') + " " +sessionStorage.getItem('ap_paterno') + " " +sessionStorage.getItem('ap_materno')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <div className="row justify-content-center align-items-center my-1 mx-2">
                                        <Card className="my-5 w-100 h-100 text-center">
                                            <div className="p-5">
                                                Estado de pago <p>{ this.formatoPago(sessionStorage.getItem('pago')) }</p>
                                            </div>
                                        </Card>
                                    </div>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}